import {
  Alert,
  schAlertSeverity,
  schAlertStatus,
  schAlertType,
  schPairedCostRouteItem,
} from '@aloft/toolkit-shared';

import { CompPropertyDataState } from '../../../../redux/types.ts';
import { AlertDefinition } from '../../types.ts';
import { getAlertTriggers } from '../utils/alertTriggers.ts';

const TIP =
  'A rating of C1-C3 is typically expected for renovated conditions. C4 is borderline acceptable.';

export const arvBelowC4: AlertDefinition = ({
  compSequence,
  compType,
  order,
  propertyDataEntities,
  fullCompSequence,
}) => {
  if (!order.hasArvOption || compType !== 'arv') return [];

  return compSequence
    .map((compID, index) => {
      const compData = propertyDataEntities[compID] as CompPropertyDataState | undefined;
      const condition = compData?.compData.editableData.improvements?.uadCondition;
      if (condition !== 5 && condition !== 6) return undefined;

      const compIndex = fullCompSequence?.indexOf(compID);
      const compLabel = `Comp ${compIndex !== undefined ? compIndex + 1 : index + 1}`;
      const targetCellKey = `${compID}-editableData.improvements.uadCondition`;

      return {
        type: schAlertType.enum.arvBelowC4,
        status: schAlertStatus.enum.active,
        severity: schAlertSeverity.enum.warning,
        orderType: ['appraisify'],
        compType,
        message: `${compLabel} has a lower than expected condition rating for an ARV`,
        propertyID: compID,
        triggers: getAlertTriggers({
          fixRoute: schPairedCostRouteItem.enum.features,
          order,
          includeUpdate: true,
        }),
        fixingInfo: {
          tips: TIP,
          pairedCostRouteItem: schPairedCostRouteItem.enum.features,
          fixingMethod: ['action'],
          commentAlwaysRequired: false,
          targetCellKey,
          targetCellKeys: [targetCellKey],
        },
      } as Alert;
    })
    .filter((alert): alert is Alert => alert !== undefined);
};
